import React from 'react';
import classNames from 'classnames';
import LayoutContainer from '../../../../components/LayoutContainer';
import './styles.css';

const Fixed = ({ show, children }) => {
  const animation = `ListviewFiltersFixed${show ? 'Down' : 'Up'}`;
  const animationDuration = 500;

  if (children)
    return (
      <div
        className={classNames('Listview__Filters__Fixed__root', {
          'Listview__Filters__Fixed__root--show': show,
        })}
        style={{
          animation: `${animation} ${animationDuration}ms cubic-bezier(0.1, 0.07, 0.44, 1) forwards`,
        }}
      >
        <LayoutContainer>
          <div className="Listview__Filters__Fixed__desktop">{children}</div>
        </LayoutContainer>
      </div>
    );
  return '';
};

export default Fixed;
